import createEmotion from '@emotion/css/create-instance';

// eslint-disable-next-line @typescript-eslint/unbound-method
export const { cx, injectGlobal, keyframes, css } = createEmotion( {
	key: 'nelio-forms',
} );
